import { MenuItem } from "@mui/material";
import { Form } from "formik";
import moment from "moment";
import * as yup from "yup";
import { convertDateTimeToNet } from "../../../utils/datetimeUtils";
import { StyledForm } from "../../styled/form";
import { StyledPaper } from "../../styled/paper";
import { FormikDateRangeInput, FormikDateRangeSearch } from "../formik/formikDateRangeSearch";
import FormikForm from "../formik/formikForm";
import FormikSelect from "../formik/formikSelect";
import FormikTextField from "../formik/formikTextField";

yup.setLocale({
  mixed: {
    notType: 'Campo inválido'
  }
});

yup.addMethod(yup.Schema, 'atLeastOne', function (fields) {
  return this.test({
    name: 'atLeastOne',
    message: 'Debe completar al menos uno de estos campos',
    test: function (value, textContext) {
      const { parent, createError, path } = textContext;
      return fields.some(f => {
        return parent[f] != null && parent[f] !== ""
      })
        ? true
        : createError({ path, message: "Debe completar al menos uno de estos campos" });
    }
  });
});
const arrayAtLeastOne = ["accident", "status", "workerId", "dateFrom", "dateTo"]

const validationSchema = yup.object().shape({
  artId: yup.string().required("Campo obligatorio"),
  workerId: yup
    .number("Ingrese sólo números")
    .integer("Ingrese sólo números")
    .typeError("Ingrese sólo números")
    .notRequired()
    .atLeastOne(arrayAtLeastOne),
  accident: yup.string().notRequired().atLeastOne(arrayAtLeastOne),
  status: yup.string().optional().atLeastOne(arrayAtLeastOne),
  datePeriod: yup.string().optional(),
  dateFrom: yup
    .date()
    .nullable()
    .notRequired()
    .when('dateTo', {
      is: (dateTo) => dateTo !== null && dateTo !== undefined,
      then: (schema) => schema.required('Ingrese una fecha desde la que buscar'),
    })
    .test('date-from-before-to', 'La fecha desde debe ser anterior o igual a la fecha hasta',
      function (value) {
        const { dateTo } = this.parent;
        if (!value || !dateTo) return true; // Skip validation if either field is empty
        return new Date(value) <= new Date(dateTo);
      }
    )
    .atLeastOne(arrayAtLeastOne),
  dateTo: yup
    .date()
    .nullable()
    .notRequired()
    .when('dateFrom', {
      is: (dateFrom) => dateFrom !== null && dateFrom !== undefined,
      then: (schema) => schema.required('Ingrese una fecha hasta la que buscar'),
    })
    .test('date-to-after-from', 'La fecha hasta debe ser posterior o igual a la fecha desde',
      function (value) {
        const { dateFrom } = this.parent;
        if (!value || !dateFrom) return true; // Skip validation if either field is empty
        return new Date(value) >= new Date(dateFrom);
      }
    )
    .atLeastOne(arrayAtLeastOne),
}, [['dateFrom', 'dateTo']]);

const initialValues = {
  artId: "",
  workerId: "",
  accident: "",
  status: "",
  datePeriod: "all",
  dateFrom: null,
  dateTo: null,
};


const SearchComponent = ({ invalid, handleSearch, handleReset, art }) => {
  const handleSubmitSearch = (values) => {

    const queryObject = {
      wri: values.artId,
    };

    if (values.accident) {
      queryObject.accident = values.accident;
    }
    if (values.workerId) {
      queryObject.workerId = values.workerId;
    }
    if (values.status !== "") {
      queryObject.status = values.status === "true" ? true : false;
    }
    if (values.dateFrom && values.dateTo) {
      queryObject.dateFrom = convertDateTimeToNet(moment(values.dateFrom).startOf("day"));
      queryObject.dateTo = convertDateTimeToNet(moment(values.dateTo).endOf("day"));
    }

    handleSearch(new URLSearchParams(queryObject).toString());
  };

  const today = new Date();

  return (
    <div>
      <StyledPaper.Container>
        <FormikForm
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmitSearch}>
          {({ values, handleSubmit, setFieldValue, errors }) => (
            <>

              <Form>
                <StyledForm.Input>
                  <FormikSelect
                    name="artId"
                    label="Art"
                    variant="standard"
                    size="medium">
                    {art.map((art) => (
                      <MenuItem value={art.id} key={art.id}>
                        {art.nombre}
                      </MenuItem>
                    ))}
                  </FormikSelect>
                </StyledForm.Input>

                <StyledForm.Input>
                  <FormikTextField
                    name="accident"
                    label="Siniestro"
                    variant="standard"
                  />
                </StyledForm.Input>
                <StyledForm.Input>
                  <FormikTextField
                    name="workerId"
                    label="Documento Trabajador"
                    variant="standard"
                  />
                </StyledForm.Input>
                <StyledForm.Input>
                  <FormikSelect
                    name="status"
                    label="Estado"
                    variant="standard"
                  >
                    <MenuItem value="">Todos</MenuItem>
                    <MenuItem value="true">Abierto</MenuItem>
                    <MenuItem value="false">Cerrado</MenuItem>
                  </FormikSelect>
                </StyledForm.Input>
                <StyledForm.Input>
                  <FormikDateRangeSearch
                    name="datePeriod"
                    label="Período"
                    variant="standard"
                    startDateFieldName="dateFrom"
                    endDateFieldName="dateTo"
                  />

                </StyledForm.Input>
                <StyledForm.Input>
                  <FormikDateRangeInput
                    name="dateFrom"
                    label="Fecha Desde"
                  />
                </StyledForm.Input>
                <StyledForm.Input>
                  <FormikDateRangeInput
                    name="dateTo"
                    label="Fecha Hasta"
                  />
                </StyledForm.Input>
              </Form>
              <StyledForm.ButtonContainer>
                <StyledForm.Button
                  variant="contained"
                  type="submit"
                  color="primary"
                  onClick={handleSubmit}
                  disabled={invalid}>
                  Buscar
                </StyledForm.Button>
              </StyledForm.ButtonContainer>
              <StyledForm.ButtonContainer>
                <StyledForm.Button
                  variant="contained"
                  type="reset"
                  color="primary"
                  onClick={() => {
                    setFieldValue("artId", initialValues.artId);
                    setFieldValue("workerId", initialValues.workerId);
                    setFieldValue("accident", initialValues.accident);
                    setFieldValue("status", initialValues.status);
                    setFieldValue("datePeriod", initialValues.datePeriod);
                    setFieldValue("dateFrom", initialValues.dateFrom);
                    setFieldValue("dateTo", initialValues.dateTo);
                    handleReset();
                  }}>
                  Limpiar
                </StyledForm.Button>
              </StyledForm.ButtonContainer>
            </>
          )}
        </FormikForm>
      </StyledPaper.Container>
    </div>
  );
};

export default SearchComponent;
